import { lazy, type ComponentType } from 'react';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const PlanejamentoPainelCarga = lazy(() => import('@/features/planejamento/components/PlanejamentoPainelCarga'));
const OrcamentoEscopoCargas = lazy(() => import('@/features/planejamento/components/OrcamentoEscopoCargas'));
const ConfigRules = lazy(() => import('@/features/permissions/components/permission/ConfigRules'));
const CableRouting = lazy(() => import('@/features/obra/components/CableRouting'));
const GoogleChatManager = lazy(() => import('@/features/admin/components/GoogleChatManager'));
const SyncOsServicoFotos = lazy(() => import('@/features/admin/components/SyncOsServicoFotos'));
const PlanejamentoAutomatico = lazy(() => import('@/features/planejamento/components/PlanejamentoAutomatico'));
const ProdutosAComprar = lazy(() => import('@/features/planejamento/components/ProdutosAComprar'));
const Notificacoes = lazy(() => import('@/features/notificacoes/components/Notificacoes'));

function makeOnBackOnly(Component: ComponentType<{ onBack: () => void }>) {
  return function View() {
    const { actions } = useNavigation();
    return <Component onBack={actions.goBack} />;
  };
}

function AutoServicesView() {
  const { selection, actions } = useNavigation();
  return <PlanejamentoAutomatico onBack={actions.goBack} preSelectedObraId={selection.obraId} />;
}

export const toolsViews: Partial<ViewRegistry> = {
  'painel-cargas': {
    component: makeOnBackOnly(PlanejamentoPainelCarga),
    guard: { screen: 'painel-cargas' },
  },
  'orcamento-escopo': {
    component: makeOnBackOnly(OrcamentoEscopoCargas),
    guard: { screen: 'orcamento-escopo' },
  },
  config: {
    component: makeOnBackOnly(ConfigRules),
    guard: { permission: 'REGRAS_CALCULO' },
  },
  'cable-routing': {
    component: makeOnBackOnly(CableRouting),
    guard: { screen: 'cable-routing' },
  },
  'google-chat-manager': {
    component: makeOnBackOnly(GoogleChatManager),
    guard: { screen: 'google-chat-manager' },
  },
  'sync-os-fotos': {
    component: makeOnBackOnly(SyncOsServicoFotos),
    guard: { screen: 'sync-os-fotos' },
  },
  'auto-services': {
    component: AutoServicesView,
    guard: { screen: 'auto-services' },
  },
  // guard por `permission` e nao por `screen`: o guard por tela resolve a
  // permissao via lookup no navigationConfig e libera a view quando o lookup
  // falha. Num painel restrito a diretoria, isso e a diferenca entre portao e
  // decoracao.
  'produtos-a-comprar': {
    component: makeOnBackOnly(ProdutosAComprar),
    guard: { permission: 'PRODUTO_A_COMPRAR' },
  },
  notificacoes: {
    component: makeOnBackOnly(Notificacoes),
    guard: { screen: 'notificacoes' },
  },
};
